import React, { useState, useEffect } from 'react';
import { Grid2, TextField, Box, Button } from '@mui/material';
import axios from 'axios';

const HomeGoodsForm = ({ apartmentId, token }) => {
  const [goods, setGoods] = useState({
    sheets_pillowcases: 0,
    comforter_duvet: 0,
    pillows: 0,
    towels: 0,
    curtains_blinds: 0,
    blinds_blinds: 0,
    rugs_carpets: 0,
    first_aid_kit: 0,
    fire_extinguisher: 0,
    iron_ironing_board: 0,
    broom_dustpan: 0,
    vacuum_cleaner: 0,
    mop_bucket: 0,
    soap_containers: 0,
  });

  const [isNewEntry, setIsNewEntry] = useState(false);

  useEffect(() => {
    const fetchGoods = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/homegoods/${apartmentId}/`);
        setGoods(response.data);
        setIsNewEntry(false);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setIsNewEntry(true);
        } else {
          console.error('Error fetching home goods data:', error);
        }
      }
    };

    fetchGoods();
  }, [apartmentId]);

  const handleQuantityChange = (field, value) => {
    setGoods(prevGoods => ({
      ...prevGoods,
      [field]: Number(value),
    }));
  };

  const handleSubmit = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/api/homegoods/${apartmentId}/`;
      const formData = new FormData();
      for (const key in goods) {
        formData.append(key, goods[key]);
      }

      if (isNewEntry) {
        await axios.post(url, formData, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        await axios.put(url, formData, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });
      }

      alert('Home goods data saved successfully!');
    } catch (error) {
      console.error('Error saving home goods data:', error);
      alert('Failed to save home goods data. Please try again.');
    }
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <Grid2 container spacing={2}>
        {Object.keys(goods).map(key => (
          <Grid2 item xs={12} sm={6} md={3} key={key}>
            <Box display="flex" alignItems="center">
              <TextField
                id={`${key}-input`}
                name={key}
                label={key.replace(/_/g, ' ').toUpperCase()}
                type="number"
                value={goods[key]}
                onChange={(e) => handleQuantityChange(key, e.target.value)}
                fullWidth
                margin="normal"
                InputProps={{ inputProps: { min: 0 } }}
              />
            </Box>
          </Grid2>
        ))}
      </Grid2>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Save
        </Button>
    </Box>
  );
};

export default HomeGoodsForm;